import React, { useState } from "react";
import PT_Report_Filter from "./pt_report_filter/PT_Report_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import PT_Report_Table from "./pt_report_table/PT_Report_Table";


const PT_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
    

      <div className="Sample_Report_Filter_div">
        <PT_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <PT_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"PT Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default PT_Report;
